import React, { useEffect, useImperativeHandle, forwardRef } from "react";
import { useNavigate } from 'react-router-dom';
import '../../App.css';
import AppBar from '@mui/material/AppBar';
import {
  Avatar, Button, Box, IconButton, 
  Menu, MenuItem,
  Toolbar, Typography
} from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { AppHelper } from '../../AppHelper';
const configJson = require('../../config.json');

const AppTopBar = forwardRef((props, ref)=> {
  const navigate = useNavigate();
  const [authOK, setAuthOK] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [ oUser, setOUser] = React.useState(null);
  const [isCenter, setIsCenter] = React.useState(false);
  const [isTutor, setIsTutor] = React.useState(false);

  useEffect(() => {
    const cached = AppHelper.userCacheGet();
    setAuthOK(!!cached);

    if (cached) {
      // Always trust the server to give the latest avatar + account type
      syncUserFromServer(cached);
    } else {
      setOUser(null);
      setIsCenter(false);
      setIsTutor(false);
    }
  }, []);

  const getAvatarUrl = (user) => {
    if (!user) return '/profile_icon/image_0_0.png';

    // New avatar system: use metadata filename first
    if (user.avatarImage) {
      return `/profile_icon/${user.avatarImage}`;
    }

    // For safety: if picture is already a filename like "image_0_1.png"
    if (user.picture && user.picture.endsWith('.png')) {
      return `/profile_icon/${user.picture}`;
    }

    // Legacy uploaded photos (base64 / jpeg path) are no longer supported
    // → fall back to a default icon instead of showing a broken grey avatar.
    return '/profile_icon/image_0_0.png';
  };

  const syncUserFromServer = async (cachedUser) => {
    if (!cachedUser || !cachedUser.token) {
      setOUser(cachedUser);
      return;
    }
    try {
      const res = await AppHelper.apiPost('api/profile/get', {
        token: cachedUser.token,
      });

      if (res && res.status) {
        const serverProfileId = res.data && res.data.profileId;
        if (serverProfileId && serverProfileId !== cachedUser.profileId) {
          setOUser(cachedUser);
          setIsCenter(cachedUser.accountType === 'TUI');
          setIsTutor(cachedUser.accountType === 'TEA');
          return;
        }
        if (res.avatarImage) {
          const updatedUser = {
            ...cachedUser,
            accountType: res.accountType || cachedUser.accountType,
            avatarImage: res.avatarImage,
            picture: res.avatarImage,
          };

          AppHelper.userCacheUpdate(updatedUser);
          setOUser(updatedUser);
          setIsCenter(updatedUser.accountType === 'TUI');
          setIsTutor(updatedUser.accountType === 'TEA');
          return;
        }
      }
    } catch (err) {
    }

    setOUser(cachedUser);
    if (cachedUser) {
      setIsCenter(cachedUser.accountType === 'TUI');
      setIsTutor(cachedUser.accountType === 'TEA');
    }
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => { setAnchorEl(null) };
  const go2Home = () => {
    navigate('/home');
  }
  const go2Login = () => {
    navigate('/login');
  }
  const go2Profile = () => {
    navigate('/profile');
  }
  const go2Tutors = () => {
    navigate('/tutor');
  }
  const go2Students = () => {
    navigate('/student');
  }
  const go2Questions = () => {
    navigate('/question');
  }
  const logMeOut = async() =>{
    if(!oUser){
      alert('No or invalid user!');
      return;
    }
    AppHelper.userCacheSet();
	  AppHelper.apiAuditPost("P-SO", "");
    go2Login();
  }
  const refreshProfile = () => {
    const cached = AppHelper.userCacheGet();
    setAuthOK(!!cached);

    if (cached) {
      setOUser(cached);
      setIsCenter(cached.accountType === 'TUI');
      setIsTutor(cached.accountType === 'TEA');
      syncUserFromServer(cached);
    } else {
      setOUser(null);
      setIsCenter(false);
      setIsTutor(false);
    }
  };
  useImperativeHandle(ref, () => ({
    refreshProfile
  }));

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar className="app-bg-g" sx={{
        }}>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <Box onClick={go2Home} component='a' sx={{cursor:'pointer', fontWeight:'bold', fontSize:'1.8rem'}}>
              EssayAce {configJson.mode!=='PROD'?'*DEV':''}
            </Box>
          </Typography>
          {
            authOK &&
              <div>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                >
                  {(!oUser) ? (
                    <AccountCircle fontSize='large' />
                  ) : (
                    <Avatar
                      src={getAvatarUrl(oUser)}
                    />
                  )}
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem onClick={go2Home}>Home</MenuItem>
                  { isCenter &&
                    <MenuItem onClick={go2Tutors}>Tutors</MenuItem>
                  }
                  { (isCenter || isTutor) &&
                    <MenuItem onClick={go2Students}>Students</MenuItem>
                  }
                  <MenuItem onClick={go2Questions}>Questions</MenuItem>
                
                  <MenuItem onClick={go2Profile}>Profile</MenuItem>
                  <MenuItem onClick={logMeOut}>Logout</MenuItem>
                </Menu>
              </div>
          }
        </Toolbar>
      </AppBar>
    </Box>
  );
});

export default AppTopBar;